import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';
import Model from 'models/Model';
import CustomPricePoint from '../customPricePoint/Model.CustomPricePoint';

export async function productCustomPricePointSaveApi(body?: Api.Core.ProductCustomPricePoint.Save.IRequest) {
  const serverResponse = await executeServerApi<
    Api.Core.ProductCustomPricePoint.Save.IRequest,
    Api.Core.ProductCustomPricePoint.Save.IResponse,
    Api.Core.ProductCustomPricePoint.Save.IHeaders
  >({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url: '/api/ProductManagement/ProductCustomPricePoint',
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
export async function productCustomPricePointListApi(body?: Api.Core.ProductCustomPricePoint.List.IRequest) {
  return await executeServerApi<
    Api.Core.ProductCustomPricePoint.List.IRequest,
    Api.Core.ProductCustomPricePoint.List.IResponse,
    Api.Core.ProductCustomPricePoint.List.IHeaders
  >({
    method: HttpMethod.get,
    url: createPathFromRoute('/api/ProductManagement/ProductCustomPricePoint'),
    body,
    headers: getDefaultHeaders(),
  });
}
export async function productCustomPricePointFindApi(body: Api.Core.ProductCustomPricePoint.Find.IRequest) {
  return await executeServerApi<
    Api.Core.ProductCustomPricePoint.Find.IRequest,
    Api.Core.ProductCustomPricePoint.Find.IResponse,
    Api.Core.ProductCustomPricePoint.Find.IHeaders
  >({
    method: HttpMethod.get,
    url: createPathFromRoute('/api/ProductManagement/ProductCustomPricePoint/:id', body),
    headers: getDefaultHeaders(),
  });
}
export async function productCustomPricePointDeleteApi(body: Api.Core.ProductCustomPricePoint.Delete.IRequest) {
  const serverResponse = await executeServerApi<
    Api.Core.ProductCustomPricePoint.Delete.IRequest,
    Api.Core.ProductCustomPricePoint.Delete.IResponse,
    Api.Core.ProductCustomPricePoint.Delete.IHeaders
  >({
    method: HttpMethod.delete,
    url: createPathFromRoute('/api/ProductManagement/ProductCustomPricePoint/:id', body),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}

export default class ProductCustomPricePoint
  extends Model<Model.IProductCustomPricePoint>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProductCustomPricePoint>
{
  id: number;
  customInfoGroup: string;

  maxPurchasePriceCAD: number;
  minPurchasePriceCAD: number;
  maxFinancedAmountCAD: number;
  minFinancedAmountCAD: number;

  productId?: number;
  productProvinceGroupId?: number;
  customPricePoints?: CustomPricePoint[];

  constructor(
    data: Partial<Model.IProductCustomPricePoint> | Utils.FormData<Model.IProductCustomPricePoint>,
    language?: Locale.Languages
  ) {
    super({ customPricePoints: [CustomPricePoint] }, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.customInfoGroup || this.id.toString(),
    };
  }

  static async list(body?: Api.Core.ProductCustomPricePoint.List.IRequest) {
    const { payload, ...rest } = await productCustomPricePointListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ProductCustomPricePoint(it)),
        count: payload.count,
      },
    };
  }
  static async find(params: { id: number }) {
    const { payload, ...rest } = await productCustomPricePointFindApi(params);
    return {
      ...rest,
      payload: new ProductCustomPricePoint(payload),
    };
  }
  async save() {
    return await productCustomPricePointSaveApi(this);
  }
  async delete() {
    return await productCustomPricePointDeleteApi(this);
  }
}
